import { render } from "./ArtifactItem.vue?vue&type=template&id=632d0887&scoped=true&ts=true"
import script from "./ArtifactItem.vue?vue&type=script&lang=ts"
export * from "./ArtifactItem.vue?vue&type=script&lang=ts"

import "./ArtifactItem.vue?vue&type=style&index=0&id=632d0887&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632d0887"]])

export default __exports__